export const ROLES = {
  GUIDE: 5,
  EVENT_STAFF: 9,
  BOOKING_MANAGER: 3,
  SALES_PARTNER: 102,
};